<template>
  <div>
    <div v-show="displayLevel">
      <div class="modifier-group d-flex d-flex-column" :class="selectedLevel > 0 && 'modifier-group__hideBorderTop'">
        <div
          class="modifier-group__header d-flex flex-align-center"
          :class="selectedLevel === 0 && 'modifier-group__header-padding'"
        >
          <div class="modifier-group__title">
            {{
              getLocalizedValue(modifierGroup.interactDisplayName) ||
              getLocalizedValue(modifierGroup.displayName) ||
              modifierGroup.name
            }}
          </div>
          <modifier-group-required-indicator
            class="modifier-group__status"
            :is-complete="isValid"
            :show-error="submitted"
            :min-limit="modifierGroup.minModifiers"
          />
        </div>
        <modifier-group-min-max-indicator class="modifier-group__min-max-value p-b-10" :group="modifierGroup" />
        <modifiers-selector
          ref="modifiers-selector"
          class="modifier-group__selectors"
          :multiple-choice="modifierGroup.multipleChoice"
          :modifier-group="modifierGroup"
          :max-limit="modifierGroup.maxModifiers"
          :selected-mods="modifierGroup.selectedModifiers"
          :modifiers="getValidModifiers"
          :parent-modifier="parentModifier"
          @onUpdateSelection="onUpdateSelection"
        >
        </modifiers-selector>
      </div>
    </div>
    <template v-for="modifier in getValidModifiers">
      <template v-for="modifierGroup in modifier.modifierGroups" :key="modifierGroup.name">
        <ModifierGroup
          :modifier-group="modifierGroup"
          :level="level + 1"
          :selected-level="selectedLevel"
          :parent-modifier="modifier.modifierId"
          :modifiers-path="modifiersPath"
          @onUpdateSelection="onUpdateSelection"
        >
        </ModifierGroup>
      </template>
    </template>
  </div>
</template>

<script>
import ModifierGroupRequiredIndicator from "./ModifierGroupRequiredIndicator.vue";
import ModifierGroupMinMaxIndicator from "./ModifierGroupMinMaxIndicator.vue";
import ModifiersSelector from "./ModifiersSelector.vue";
import { getLocalizedValue } from "@/utils";
export default {
  name: "ModifierGroup",
  components: { ModifierGroupRequiredIndicator, ModifierGroupMinMaxIndicator, ModifiersSelector },
  props: {
    modifierGroup: Object,
    level: Number,
    selectedLevel: Number,
    parentModifier: String,
    modifiersPath: Array,
    submitted: Boolean,
    validNestedSelection: Boolean
  },
  emits: ["onUpdateSelection"],
  computed: {
    getValidModifiers() {
      return this.modifierGroup.modifiers.filter((modifier) => modifier);
    },
    displayLevel() {
      return (
        this.level === this.selectedLevel &&
        this.modifierGroup.modifiers.length &&
        (this.selectedLevel === 0 || this.parentModifier === this.modifiersPath[this.modifiersPath.length - 1]?.modifierId)
      );
    },
    selectedModifierArray() {
      const { selectedModifiers } = this.modifierGroup;
      if (Array.isArray(selectedModifiers)) {
        return selectedModifiers;
      }
      return selectedModifiers ? [selectedModifiers] : [];
    },
    isValid() {
      const { minModifiers, maxModifiers } = this.modifierGroup;

      return (
        this.selectedModifierArray?.length >= minModifiers &&
        this.selectedModifierArray?.length <= maxModifiers &&
        (!this.$refs["modifiers-selector"] || this.$refs["modifiers-selector"].isValid())
      );
    }
  },
  methods: {
    getLocalizedValue,
    onUpdateSelection(payload) {
      this.$emit("onUpdateSelection", payload);
    }
  }
};
</script>
<style lang="scss">
.modifier-group {
  margin-bottom: 20px;
  border-top: 12px solid rgba(141, 154, 174, 0.08);

  &__header {
    color: $group-3-color-2;
    font-size: 14px;
    height: 24px;
    margin-top: 14px;
  }

  &__title {
    flex-basis: 100%;
    font-size: 20px;
    font-weight: bold;
  }

  &__min-max-value {
    color: $group-3-color-3;
    font-size: 14px;
  }

  &__status {
    white-space: nowrap;
    color: $text-color;
  }

  &__hideBorderTop {
    border-top: none;
  }
  &__header-padding {
    padding-top: 10px;
  }
  &__selectors {
    .modifier {
      align-items: center;
      border-bottom: 0.5px solid #d7d7d7;
      font-size: 15px;
      font-weight: 500;

      &__description {
        font-size: $spacer;
        color: $group-3-color-2;
      }
    }

    .modifier:last-child {
      border-bottom: none;
    }
  }
}
</style>
